import React, { useContext, useEffect, useState } from "react";
import {
  Typography,
  Container,
  Box,
  Card,
  CardContent,
  Avatar,
  Grid,
  CardMedia,
  Button,
  CircularProgress, // 1. Добавлено для загрузки
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // 2. Добавлено для навигации
// --- 3. ИСПРАВЛЕННЫЕ ПУТИ ИМПОРТА ---
import { LangContext } from "../LanguageProvider";
import useAuthStore from "../services/AuthStore"; // (Путь изменен с ../../ на ../)
import StopBullyingBanner from "./StopBullyingBanner";
import { FlyerCard } from "../components/maincomp/FlyerCard";
import useGrowingText from "./useGrowingText";
import YandexMap from "../components/maincomp/Yandexmap";
// ---

// 4. Утилита для обрезки текста (из вашего News.js)
const truncateText = (text, limit) => {
  if (!text) return "";
  return text.length > limit ? text.substring(0, limit) + "..." : text;
};

function MainPage() {
  // 5. Получаем 'lang' для мультиязычности новостей
  const { translations, lang } = useContext(LangContext);
  const { containerRef, isVisible } = useGrowingText();
  const navigate = useNavigate();

  // --- 6. Логика для загрузки новостей ---
  const { getNews } = useAuthStore();
  const [latestNews, setLatestNews] = useState([]);
  const [isLoadingNews, setIsLoadingNews] = useState(true);

  useEffect(() => {
    const fetchLatestNews = async () => {
      try {
        setIsLoadingNews(true);
        // Получаем 1 страницу, 3 новости (backend сортирует по дате)
        const data = await getNews(1, 3);
        // data теперь объект { news: [...], total: ... }
        setLatestNews(data.news);
      } catch (error) {
        console.error("Failed to fetch latest news:", error);
      } finally {
        setIsLoadingNews(false);
      }
    };
    fetchLatestNews();
  }, [getNews]);
  // --- Конец логики новостей ---

  return (
    // 7. Улучшен фон и высота
    <Box sx={{ minHeight: "100vh", backgroundColor: "grey.100", pb: 10 }}>
      {/* Контейнер для флаера */}
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          justifyContent: "center",
          paddingLeft: { xs: 0, md: 6 },
          paddingRight: { xs: 0, md: 2 },
          marginTop: "60px",
        }}>
        <FlyerCard translations={translations} />
      </Container>

      {/* Баннер (Уменьшен отступ) */}
      <Container
        sx={{
          marginTop: 10, // 8. Уменьшен отступ (было 20)
          borderRadius: "50px",
          maxWidth: "900px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          boxSizing: "border-box",
        }}>
        <StopBullyingBanner />
      </Container>

      <Container
        maxWidth="false"
        style={{
          width: "100%",
          paddingLeft: { xs: 0, md: 6 },
          paddingRight: { xs: 0, md: 2 },
        }}>
        <Grid
          container
          spacing={0} //уменьшение отступов
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 16px",
          }}>
          {/* --- 9. Раздел Новостей (Полностью обновлен) --- */}
          <Grid item xs={12} lg={12}>
            <Container
              sx={{
                marginTop: 10, // Уменьшен отступ (было 20)
                border: "2px solid #e0e0e0",
                borderRadius: 8,
                padding: 3,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#ffffff", // Явный белый фон
                maxWidth: "1000px",
              }}>
              <Typography
                variant="h5"
                gutterBottom
                style={{ color: "#000000", marginBottom: 20 }}>
                {translations["news"]}
              </Typography>

              {/* Контейнер для карточек */}
              <Box
                display="flex"
                justifyContent="center" // Центрируем, если карточек меньше 3
                gap={3} // Уменьшен gap
                flexWrap="wrap"
                sx={{
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "center", sm: "stretch" }, // Stretch для одинаковой высоты
                }}>
                {/* 10. Показываем загрузчик или новости */}
                {isLoadingNews ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 300,
                      width: "100%",
                    }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  // 11. Рендерим 3 новости из 'latestNews'
                  latestNews.map(newsItem => (
                    <Card
                      key={newsItem.id}
                      sx={{
                        width: "100%",
                        maxWidth: { sm: 300 }, // Немного уменьшим для 3х в ряд
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between", // Растягиваем контент
                        boxShadow: 4,
                        borderRadius: 3,
                        border: "1px solid #e0e0e0",
                        transition: "transform 0.3s ease-in-out",
                        "&:hover": { transform: "scale(1.02)" },
                      }}>
                      {/* 12. Логика для Base64 изображений */}
                      <CardMedia
                        component="img"
                        image={
                          newsItem.images && newsItem.images.length > 0
                            ? `data:;base64,${newsItem.images[0]}`
                            : "https://placehold.co/400x250/e0e0e0/757575?text=RVTK" // Заглушка
                        }
                        alt={newsItem.title_ru}
                        sx={{
                          width: "100%",
                          height: 200, // Уменьшена высота
                          objectFit: "cover",
                          margin: "0 auto",
                          borderBottom: "1px solid #e0e0e0",
                        }}
                      />
                      <CardContent sx={{ flexGrow: 1 }}>
                        {/* 13. Мультиязычный и обрезанный текст */}
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", marginBottom: 1 }}>
                          {truncateText(
                            lang === "kz"
                              ? newsItem.title_kz
                              : newsItem.title_ru,
                            30,
                          )}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{
                            marginBottom: 2,
                            height: 60,
                            overflow: "hidden",
                          }}>
                          {truncateText(
                            lang === "kz"
                              ? newsItem.description_kz
                              : newsItem.description_ru,
                            70, // Чуть больше описания
                          )}
                        </Typography>
                      </CardContent>
                      <Box sx={{ p: 2, pt: 0 }}>
                        {/* 14. Кнопка с навигацией */}
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={() => navigate(`/news/${newsItem.id}`)}>
                          {translations["Read more"]}
                        </Button>
                      </Box>
                    </Card>
                  ))
                )}
              </Box>
            </Container>
          </Grid>

          {/* Раздел Администрации (Уменьшен отступ) */}
          <Grid item xs={12} lg={12}>
            <Container
              sx={{
                marginTop: 10, // Уменьшен отступ (было 20)
                border: "2px solid #e0e0e0",
                borderRadius: 8,
                padding: 3,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                marginBottom: 10,
                maxWidth: "1000px",
                height: "auto",
                backgroundColor: "#ffffff",
              }}>
              <Typography
                variant="h5"
                gutterBottom
                style={{ color: "#000000", marginBottom: 20 }}>
                {translations["administration"]}{" "}
              </Typography>

              <Box
                display="flex"
                justifyContent="center" // Центрируем одну карточку
                gap={4} // Уменьшен gap (было 14)
                sx={{
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "center", sm: "flex-start" },
                }}>
                {/* Карточка президента */}
                <Card
                  sx={{
                    width: "100%",
                    maxWidth: { sm: 400 },
                    maxHeight: "500px",
                    boxShadow: 4,
                    borderRadius: 3,
                    textAlign: "center",
                    padding: 0,
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": { transform: "scale(1.02)" },
                  }}>
                  <CardContent>
                    <Avatar
                      src="/Director2.jpeg"
                      alt="Director2"
                      variant="square" // Убрано скругление, чтобы соответствовать CardMedia
                      sx={{
                        width: "100%",
                        height: 250,
                        margin: "0 auto",
                        objectFit: "cover",
                        // Убраны кастомные borderRadius
                      }}
                    />
                    <Typography
                      variant="h6"
                      sx={{ color: "black", fontWeight: "bold", mt: 2 }}>
                      {translations["Aida"]}{" "}
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500, mt: 1 }}>
                      Маратова Аида Маратовна
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mt: 1 }}>
                      Почта: maratova_@mail.ru
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mt: 1 }}>
                      Контактный телефон: 8(7112)50-34-20, 8-775-666-75-39
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </Container>
          </Grid>
        </Grid>

        {/* 15. Секция статистики (Улучшен фон) */}
        <Container
          sx={{
            marginTop: 4,
            marginBottom: 0,
            maxWidth: "1000px",
            width: "100%",
            height: "auto",
            // Улучшенный фон
            background: "linear-gradient(145deg, #192a56, #273c75)",
            borderRadius: 8,
            display: "flex",
            justifyContent: "space-between",
            alignItems: { sm: "flex-start", xs: "center" },
            flexDirection: { xs: "column", sm: "row" },
            color: "Gold",
            padding: 4, // Добавлены внутренние отступы
          }}>
          {/* Первая колонка */}
          <Box
            ref={containerRef}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center", // Добавлено
              transition: "transform 0.8s ease-out, opacity 0.8s ease-out",
              transform: isVisible ? "scale(1)" : "scale(0.2)",
              opacity: isVisible ? 1 : 0.3,
              marginBottom: { xs: "30px", sm: 0 },
            }}>
            {/* ... (Ваш код для 16) ... */}
            <Typography
              variant="h6"
              sx={{
                backgroundImage:
                  "linear-gradient(360deg,rgb(255, 0, 0),rgb(233, 135, 8),rgb(255, 238, 0))",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}>
              {translations["valuecollege"]}{" "}
            </Typography>
            <Typography
              variant="h1"
              sx={{
                marginTop: "80px",
                backgroundImage:
                  "linear-gradient(360deg, rgb(255, 0, 0) 10%, rgb(233, 135, 8) 50%, rgb(255, 238, 0) 90%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}>
              16
            </Typography>
            <Typography variant="h6" color="white">
              {translations["16"]}{" "}
            </Typography>
            <Typography
              variant="body1" // 16. Изменено на body1 для лучшей читаемости
              color="white"
              sx={{ whiteSpace: "normal", maxWidth: "100%" }}>
              {translations["16.2"]}{" "}
            </Typography>
          </Box>

          {/* Вторая колонка */}
          <Box
            ref={containerRef}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              transition: "transform 0.8s ease-out, opacity 0.8s ease-out",
              transform: isVisible ? "scale(1) " : "scale(0.2) ",
              opacity: isVisible ? 1 : 0.3,
              marginBottom: { xs: "30px", sm: 0 },
            }}>
            {/* ... (Ваш код для 135) ... */}
            <Typography
              variant="h1"
              sx={{
                marginTop: "110px",
                backgroundImage:
                  "linear-gradient(360deg,rgb(255, 0, 0),rgb(233, 135, 8),rgb(255, 238, 0))",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}>
              135
            </Typography>
            <Typography color="white" variant="h6">
              {translations["135"]}{" "}
            </Typography>
            <Typography variant="body1" color="white">
              {translations["135.2"]}{" "}
            </Typography>
          </Box>

          {/* Третья колонка */}
          <Box
            ref={containerRef}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              transition: "transform 0.8s ease-out, opacity 0.8s ease-out",
              transform: isVisible ? "scale(1) " : "scale(0.2) ",
              opacity: isVisible ? 1 : 0.1,
              marginBottom: { xs: "30px", sm: 0 },
            }}>
            {/* ... (Ваш код для 35) ... */}
            <Typography
              variant="h1"
              sx={{
                marginTop: "110px",
                backgroundImage:
                  "linear-gradient(360deg,rgb(255, 0, 0),rgb(233, 135, 8),rgb(255, 238, 0))",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}>
              35
            </Typography>
            <Typography variant="h6" color="white">
              {translations["35"]}{" "}
            </Typography>
            <Typography variant="body1" color="white">
              {translations["35.2"]}{" "}
            </Typography>
          </Box>
        </Container>

        {/* Раздел Спонсоров */}
        <Container
          sx={{
            marginTop: 10,
            marginBottom: 10,
            border: "2px solid #e0e0e0",
            borderRadius: 8,
            padding: 3,
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            maxWidth: "1000px",
            backgroundColor: "#ffffff",
          }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ color: "#000000", marginBottom: 4, textAlign: "center" }}>
            {translations["partners"]}{" "}
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {[
              {
                id: 1,
                name: "IT Hub",
                image: "/photo/partners/ithub.png",
              },
              {
                id: 2,
                name: "IT Group",
                image: "/photo/partners/itgroup.png",
              },
              {
                id: 3,
                name: "Kazakhtelecom",
                image: "/photo/partners/kaztelecom.png",
              },
            ].map(sponsor => (
              <Grid item xs={12} sm={6} md={4} key={sponsor.id}>
                <Card
                  sx={{
                    maxWidth: 345,
                    margin: "0 auto", // Центрирование
                    boxShadow: 4,
                    borderRadius: 3,
                    textAlign: "center",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    transition: "transform 0.3s ease-in-out",
                  }}>
                  <Box
                    sx={{
                      height: 200,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 2,
                    }}>
                    <CardMedia
                      component="img"
                      sx={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                      image={sponsor.image}
                      alt={sponsor.name}
                    />
                  </Box>
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      {sponsor.name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Карта */}
        <Container
          sx={{
            marginTop: 10,
            marginBottom: 10,
            border: "2px solid #e0e0e0",
            borderRadius: 8,
            padding: 3,
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            maxWidth: "1000px",
            backgroundColor: "#ffffff",
          }}>
          <Typography
            variant="h5"
            sx={{
              color: "black",
              textAlign: "center",
              marginBottom: "10px",
            }}>
            {translations["map"]}{" "}
          </Typography>
          <YandexMap />
        </Container>
      </Container>
    </Box>
  );
}

export default MainPage;
